import React, { useState, useCallback } from 'react'
import PropTypes from 'prop-types'

const BuildingSizeNumberField = ({
    input,
    label,
    type,
    meta,
    placeholder,
    // css classes
    errorClassName,
    groupClassName,
    inputClassName,
    inputErrorClassName,
    labelClassName,
}) => {
    const [values, setValue] = useState('');

    const handleChange = useCallback((e) => {
        const value = e.target.value;
        const regex = /([0-9]+$)/i
        const isValidValue = regex.test(value) && value > 0
        if (!value.length) return setValue('')
        if (!isValidValue) return;
        return setValue(value)
    }, [])

    return (
        <>
            <div className={groupClassName}>
                <label className={labelClassName}>
                    {label}
                </label>
                <input
                    {...input}
                    onChange={handleChange}
                    value={values}
                    className={
                        meta.touched && meta.error
                            ? [inputClassName, inputErrorClassName].join(' ')
                            : inputClassName
                    }
                    placeholder={placeholder}
                    type={type}
                />
                {meta.touched && meta.error && <p className={errorClassName}>{meta.error}</p>}
            </div>
        </>
    )
}

BuildingSizeNumberField.propTypes = {
    input: PropTypes.object.isRequired,
    type: PropTypes.string,
    meta: PropTypes.object.isRequired,
    placeholder: PropTypes.string,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    groupClassName: PropTypes.string,
    labelClassName: PropTypes.string,
    inputClassName: PropTypes.string,
    errorClassName: PropTypes.string,
    inputErrorClassName: PropTypes.string,
    customOnChange: PropTypes.func
}

export default BuildingSizeNumberField
